import { gql } from '@apollo/client'

export type MutationVars = {
  customerId: string
  subjectId: string
  notificationId: string
}

export type Response = {
  resendNotification: string
}

const mutation = gql`
  mutation resendNotification(
    $customerId: String!
    $subjectId: String!
    $notificationId: String!
  ) {
    resendNotification(
      customerId: $customerId
      subjectId: $subjectId
      notificationId: $notificationId
    )
  }
`

export default mutation
